import React from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import ChatWidget from "@/components/ChatWidget";

export default function WidgetPlayground({ business }) {
  const accent = business.config.accent_color;
  return (
    <div className="grid lg:grid-cols-5 gap-6 items-start">
      <div className="lg:col-span-3 rounded-2xl border border-border overflow-hidden relative min-h-[560px] grain"
        style={{ background: "hsl(var(--secondary))" }}>
        <div className="p-8">
          <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-2">Simulasi Storefront</p>
          <h3 className="font-display text-2xl font-bold tracking-tight">{business.name}</h3>
          <p className="text-muted-foreground mt-2 max-w-md text-sm">
            Ini simulasi website bisnis. Widget AI Sales Assistant tampil di pojok kanan bawah persis seperti
            saat script embed dipasang di website asli. Klik untuk mulai chat.
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-8">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="rounded-xl bg-card border border-border h-28 flex items-center justify-center">
                <div className="w-10 h-10 rounded-lg" style={{ background: accent + "22" }} />
              </div>
            ))}
          </div>
        </div>

        <motion.div className="absolute bottom-6 right-6" initial={{ scale: 0 }} animate={{ scale: 1 }}>
          <div className="w-14 h-14 rounded-full flex items-center justify-center pulse-ring cursor-default"
            data-testid="floating-widget-trigger"
            style={{ background: accent, "--pulse-color": accent + "73" }}>
            <MessageCircle className="w-6 h-6 text-white" />
          </div>
        </motion.div>
      </div>

      <div className="lg:col-span-2">
        <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-3">Live Chat</p>
        <div className="rounded-2xl border border-border overflow-hidden shadow-lg h-[560px]" data-testid="chat-widget-window">
          <ChatWidget key={business.id} token={business.token} accentOverride={accent} showDataSource />
        </div>
      </div>
    </div>
  );
}
